import { api } from './client';

export interface ContactMessage {
  id: number;
  name: string;
  email: string;
  phone?: string;
  company?: string;
  subject?: string;
  message: string;
  status: 'unread' | 'read' | 'replied';
  created_at: string;
}

export interface CreateContactRequest {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  subject?: string;
  message: string;
}

export const contactApi = {
  sendMessage: (data: CreateContactRequest) =>
    api.post<ContactMessage>('/contact/', data),

  getMessages: () =>
    api.get<ContactMessage[]>('/contact/'),

  getMessage: (id: number) =>
    api.get<ContactMessage>(`/contact/${id}/`),

  updateMessageStatus: (id: number, status: string) =>
    api.patch<ContactMessage>(`/contact/${id}/`, { status }),
};
